import React from 'react'
import './styles.scss'

interface Props {
  data: [string, string, string, number]
  locale: string
}

export const Weekdate = ({ data, locale }: Props) => {
  return (
    <div className={`Weekdate`}>
      {data && (
        <div className='inner'>
          {locale}
          <br />
          {data[2]}
        </div>
      )}
    </div>
  )
}
